export enum VictoryCriteriaEnum {
    PONTUACAO_TOTAL = 'PONTUACAO_TOTAL',
    PERIODOS_GANHOS = 'PERIODOS_GANHOS'    
}
